import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import api from "../../utils/api";

const CACHE_TTL_MS = 15000;

export const fetchOrders = createAsyncThunk(
  "orders/fetch",
  async () => {
    const res = await api.get("/vendor/orders");
    return res.data.orders;
  },
  {
    condition: (arg = {}, { getState }) => {
      if (arg?.force) return true;
      const state = getState()?.orders;
      if (state?.loading) return false;
      if (!state?.items?.length || !state?._lastFetchAt) return true;
      return Date.now() - state._lastFetchAt > CACHE_TTL_MS;
    },
  }
);

const ordersSlice = createSlice({
  name: "orders",
  initialState: {
    items: [],
    loading: false,
    error: null,
    _lastFetchAt: 0,
  },
  reducers: {
    patchOrderStatus: (state, action) => {
      const { id, status } = action.payload || {};
      if (!id || !status) return;
      state.items = (state.items || []).map((o) =>
        o && o.id === id ? { ...o, status } : o
      );
      state._lastFetchAt = Date.now();
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchOrders.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchOrders.fulfilled, (state, action) => {
        state.loading = false;
        state.items = action.payload;
        state._lastFetchAt = Date.now();
      })
      .addCase(fetchOrders.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      });
  },
});

export const { patchOrderStatus } = ordersSlice.actions;
export default ordersSlice.reducer;
